const location = () => {
  let location = window.location.protocol + '//' + window.location.hostname +
    window.location.pathname + window.location.search + window.location.hash

  return location
}

const ua = navigator.userAgent

const isWebShareApiSupported = (shareParams) => {
  return navigator && typeof navigator.canShare !== 'undefined' && navigator.canShare(shareParams)
}

const isMobileOrTablet = () => {
  return /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|Opera Mobi|IEMobile/i.test(ua)
}

const isIos = () => {
  return /iPad|iPhone|iPod|Mac/i.test(ua)
}

const isWindowsPhone = () => {
  return navigator.userAgent.toLowerCase().indexOf('windows phone') > -1
}

const isAndroid = () => {
  return /Android/i.test(ua)
}

const isAndroidIos = () => {
  return navigator.userAgent.match(/Android|iPhone|iPad/i).length > 0
}

const isDefectAndroid = () => {
  return (navigator.userAgent.indexOf('537.36') > 0 && navigator.userAgent.toLowerCase().match(/android/))
}

const isRebtel = () => {
  return navigator.userAgent.toLowerCase().indexOf('rebtel') > -1
}

const isChrome = () => {
  return navigator.userAgent.indexOf('Chrome') > -1
}

const isFirefox = () => {
  return navigator.userAgent.indexOf('Firefox') > -1
}

const isSafari = () => {
  return navigator.userAgent.indexOf('Safari') > -1
}

const isOpera = () => {
  return navigator.userAgent.toLowerCase().indexOf('op') > -1
}

const isOperaMini = () => {
  return navigator.userAgent.indexOf('Opera Mini') > -1
}

const isIE = () => {
  let isIE = false

  if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
    isIE = true
  }

  return isIE
}

const os = () => {
  let ua = navigator.userAgent.toLowerCase()

  // Windows Phone
  if (ua.indexOf('windows phone') >= 0) {
    return 'windowsphone'
  }

  // Windows
  if (ua.indexOf('windows') >= 0) {
    return 'windows'
  }

  // Android
  if (ua.indexOf('android') >= 0) {
    return 'android'
  }

  // iOS
  if (ua.indexOf('apple-i') >= 0) {
    return 'ios'
  }

  if (ua.indexOf('iphone') >= 0) {
    return 'ios'
  }

  if (ua.indexOf('ipad') >= 0) {
    return 'ios'
  }

  // BlackBerry
  if (ua.indexOf('blackberry') >= 0) {
    return 'blackberry'
  }

  // BlackBerry
  if (ua.indexOf('(bb') >= 0) {
    return 'blackberry'
  }

  // Kindle
  if (ua.indexOf('kindle') >= 0) {
    return 'kindle'
  }

  // Macintosh
  if (ua.indexOf('macintosh') >= 0) {
    return 'mac'
  }

  // Linux
  if (ua.indexOf('linux') >= 0) {
    return 'linux'
  }

  // OpenBSD
  if (ua.indexOf('openbsd') >= 0) {
    return 'openbsd'
  }

  // Firefox OS
  if (ua.indexOf('firefox') >= 0) {
    return 'firefoxos' // Web is the plaform
  }

  return 'unknown'
}

/*
  Retrieve browser version (Vendor + Version)
*/
const getBrowserInfo = () => {
  let ua = navigator.userAgent

  let tem
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

  let browser

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    browser = 'IE ' + (tem[1] || '')
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR\/(\d+)/)

    if (tem !== null) {
      browser = 'Opera ' + tem[1]
    }
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']

  if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
    M.splice(1, 1, tem[1])
  }

  browser = M.join('/')

  // WTB-844 [BUG] iOS inapp browser unable to Signup error
  if (browser.length > 50) {
    browser = browser.substring(0, 50)
  }

  return browser
}

/*
  Retrieve type of OS
*/
const getPlatformInfo = () => {
  return navigator.platform
}

const ieVersion = () => {
  let iev = 0
  let ieold = (/MSIE (\d+\.\d+)/.test(navigator.userAgent))
  let trident = !!navigator.userAgent.match(/Trident\/7.0/)
  let rv = navigator.userAgent.indexOf('rv:11.0')

  if (ieold) {
    iev = Number(RegExp.$1)
  }

  if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
    iev = 10
  }

  if (trident && rv !== -1) {
    iev = 11
  }

  return iev
}

export {
  isWebShareApiSupported,
  getPlatformInfo,
  getBrowserInfo,
  location,
  isMobileOrTablet,
  isIos,
  isWindowsPhone,
  isAndroid,
  isAndroidIos,
  isDefectAndroid,
  isRebtel,
  isChrome,
  isFirefox,
  isSafari,
  isOpera,
  isOperaMini,
  isIE,
  os,
  ieVersion
}



// WEBPACK FOOTER //
// ./src/utils/browser.js